/**
 * Sort beer rows for Featured Beer tab: brewery name A–Z, then beer name A–Z.
 * @param {object[]} beers - Beer-shaped objects with breweryName and name
 * @returns {object[]} New sorted array
 */
export function sortFeaturedBeersByBreweryThenName(beers) {
  if (!Array.isArray(beers) || beers.length === 0) {
    return [];
  }
  return [...beers].sort((beerLeft, beerRight) => {
    const breweryLeft = String(beerLeft?.breweryName ?? '').trim();
    const breweryRight = String(beerRight?.breweryName ?? '').trim();
    const breweryCmp = breweryLeft.localeCompare(breweryRight);
    if (breweryCmp !== 0) {
      return breweryCmp;
    }
    const nameLeft = String(beerLeft?.name ?? '').trim();
    const nameRight = String(beerRight?.name ?? '').trim();
    return nameLeft.localeCompare(nameRight);
  });
}
